import { ID_KEY, ROLE_KEY, SUPER_USER_TOKEN_KEY, TOKEN_KEY } from '../Config/Constants';

export const clearUserCache = () => {
	localStorage.removeItem(ID_KEY);
	localStorage.removeItem(ROLE_KEY);
	localStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(SUPER_USER_TOKEN_KEY);
};
